import { SalaryOnboardingStageForm } from '@Page/Onboarding/SalaryOnboardingStage';
import { useIntl } from 'react-intl';
import { AppDownload } from '@tlx/beehive-shared';
import { useTskContext } from '@Hooks/useTskContext';

export function TipsStage() {
    const intl = useIntl();
    const { contextCompanyId, loginEmployeeId } = useTskContext();
    return (
        <SalaryOnboardingStageForm
            title={intl.formatMessage({ id: 'text_well_done' })}
            description={intl.formatMessage({
                id: 'tsk_onboarding_done_description',
            })}
        >
            <AppDownload
                page={'TravelsAndExpenses'}
                loginCompanyId={contextCompanyId}
                loginEmployeeId={loginEmployeeId}
            />
        </SalaryOnboardingStageForm>
    );
}
